import Touchable from '@components/Touchable'
import useConfig from '@plug-core/hooks/useConfig'
import useToken from '@plug-core/hooks/useToken'
import { formatMoney } from '@plug-core/utils/formatNumber'
import { Avatar, ListItemAvatar, ListItemText, Paper, Stack } from '@mui/material'
import React from 'react'

import type { SNS } from '@plug-core/interfaces/common'

export interface TokenListItemProps {
  sns: SNS
  onClick?: (sns: SNS) => void
}

export const TokenGridItem = ({ sns, onClick }: TokenListItemProps) => {
  const { id, name, logo } = useToken(sns.ledgerCanisterId)
  const { tokenPricesWithChange } = useConfig()

  const price = id ? tokenPricesWithChange[id] : undefined

  return (
    <Stack>
      <Touchable onClick={() => onClick?.(sns)}>
        <Stack
          component={Paper}
          p={2}
          sx={{ boxSizing: 'border-box' }}
          elevation={0}
          width={150}
          height={150}
        >
          <ListItemAvatar>
            <Avatar src={logo} />
          </ListItemAvatar>
          <ListItemText
            primary={name}
            primaryTypographyProps={{
              sx: {
                display: '-webkit-box',
                WebkitLineClamp: 1,
                overflow: 'hidden',
                WebkitBoxOrient: 'vertical',
              },
            }}
            secondary={formatMoney(price?.price, undefined, {
              format: 'precise',
            })}
          />
          {price && (
            <ListItemText
              secondaryTypographyProps={{
                color: price.priceChange > 0 ? 'rainbow.green' : 'rainbow.red',
              }}
              secondary={`${price.priceChange.toFixed(2)}%`}
            />
          )}
        </Stack>
      </Touchable>
    </Stack>
  )
}
